exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mask[data-v-ffeab266] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n.common-tree[data-v-ffeab266] {\n  overflow: auto;\n}", ""]);

// exports
